import { ReactNode } from 'react'
import { ORIGIN_REMAP_GUIDE_QUERIES_URL } from './originRemap'

export const OriginRemapGuideLink = ({ children }: { children: ReactNode }): JSX.Element => (
  <a href={ORIGIN_REMAP_GUIDE_QUERIES_URL} target="_blank" rel="noreferrer">
    {children}
  </a>
)
